<template>
	
	<el-dialog :title="titleMap[mode]" v-model="visible" :width="width" destroy-on-close @closed="$emit('closed')">
		<el-form :model="form" :rules="rules" :disabled="mode=='show'" ref="dialogForm" label-width="100px">
            <el-row :gutter="15">
                <template v-for="(item,index) in formItems || config.formItems" :key="index">
                    <el-col :span="item.span||24">
                        <mn-title  v-if="item.component=='title'"  :title="item.label"></mn-title>
                        <el-form-item v-else :prop="item.name">
                            <template #label>
                                {{item.label}}
                                <el-tooltip v-if="item.tips" :content="item.tips">
                                    <el-icon><el-icon-question-filled /></el-icon>
                                </el-tooltip>
                            </template>
                            <!-- input -->
                            <template v-if="item.component=='input'" >
                                <el-input v-model="form[item.name]" :placeholder="item.options.placeholder" clearable :maxlength="item.options.maxlength" show-word-limit></el-input>
                            </template>
                            <!-- checkbox -->
							<template v-else-if="item.component=='image'">
								<el-input v-model="form[item.name]" clearable></el-input>
								<div>
									<mnUploadImg :select="form[item.select]" ref="mui"></mnUploadImg>
									<div v-if="form[item.name]" class="imglist">
										<div class="imgbox" v-for="(_item,_index) in form[item.name].split(',')" :key="_index">
											<img class="img" :src="_item" alt="">
										</div>
									</div>
								</div>
							</template>
                            <template v-else-if="item.component=='checkbox'" >
                                <template v-if="item.name" >
                                    <el-checkbox v-model="form[item.name][_item.name]" :label="_item.label"  v-for="(_item, _index) in item.options.items" :key="_index"></el-checkbox>
                                </template>
                                <template v-else >
                                    <el-checkbox v-model="form[_item.name]" :label="_item.label"  v-for="(_item, _index) in item.options.items" :key="_index"></el-checkbox>
                                </template>
                            </template>
                            <!-- checkboxGroup -->
                            <template v-else-if="item.component=='checkboxGroup'" >
                                <el-checkbox-group v-model="form[item.name]">
                                    <el-checkbox v-for="_item in item.options.items" :key="_item.value" :label="_item.value">{{_item.label}}</el-checkbox>
                                </el-checkbox-group>
                            </template>
                            <!-- upload -->
                            <template v-else-if="item.component=='upload'" >
                                <el-col v-for="(_item, _index) in item.options.items" :key="_index">
                                    <el-form-item :prop="_item.name">
                                        <mn-upload v-model="form[_item.name]" :title="_item.label"></mn-upload>
                                    </el-form-item>
                                </el-col>
                            </template>
                            <!-- switch -->
                            <template v-else-if="item.component=='switch'" >
                                <el-switch v-model="form[item.name]" />
                            </template>
                            <!-- select -->
                            <template v-else-if="item.component=='select'" >
                                <el-select v-model="form[item.name]" :multiple="item.options.multiple" :placeholder="item.options.placeholder" clearable filterable style="width: 100%;">
                                    <el-option v-for="option in item.options.items" :key="option.value" :label="option.label" :value="option.value"></el-option>
                                </el-select>
                            </template>
                            <!-- cascader -->
                            <template v-else-if="item.component=='cascader'">
								<template v-if="!item.only">
									<el-cascader v-model="form[item.name]" :options="item.options.items" clearable></el-cascader>
								</template>
								<template v-else>
									<el-cascader v-model="form[item.name]" :options="item.options.items" :props="groupsProps" clearable :show-all-levels="false"></el-cascader>
								</template>
                            </template>
                            <!-- showondcascader -->
                            <template v-else-if="item.component=='showondcascader'" >
                                <el-cascader v-model="form[item.name]" :options="item.options.items"  :show-all-levels="false" clearable></el-cascader>
                            </template>
                            <!-- date -->
                            <template v-else-if="item.component=='date'" >
                                <el-date-picker v-model="form[item.name]" :type="item.options.type" :shortcuts="item.options.shortcuts" :default-time="item.options.defaultTime" :value-format="item.options.valueFormat" :placeholder="item.options.placeholder || '请选择'"></el-date-picker>
                            </template>
                            <!-- number -->
                            <template v-else-if="item.component=='number'" >
                                <el-input-number v-model="form[item.name]" controls-position="right"></el-input-number>
                            </template>
                            <!-- radio -->
                            <template v-else-if="item.component=='radio'" >
                                <el-radio-group v-model="form[item.name]">
                                    <el-radio v-for="_item in item.options.items" :key="_item.value" :label="_item.value">{{_item.label}}</el-radio>
                                </el-radio-group>
                            </template>
                            <!-- color -->
                            <template v-else-if="item.component=='color'" >
                                <el-color-picker v-model="form[item.name]" />
                            </template>
                            <!-- rate -->
                            <template v-else-if="item.component=='rate'" >
                                <el-rate style="margin-top: 6px;" v-model="form[item.name]"></el-rate>
                            </template>
                            <!-- slider -->
                            <template v-else-if="item.component=='slider'" >
                                <el-slider v-model="form[item.name]" :marks="item.options.marks"></el-slider>
                            </template>
							<!-- tableselect -->
							<template v-else-if="item.component=='tableselect'" >
								<tableselect-render v-model="form[item.name]" :item="item"></tableselect-render>
							</template>
                            <!-- editor -->
                            <template v-else-if="item.component=='editor'" >
                                <mn-editor v-model="form[item.name]" placeholder="请输入" :height="400"></mn-editor>
                            </template>
                            <!-- noComponent -->
                            <template v-else>
                                <el-tag type="danger">[{{item.component}}] Component not found</el-tag>
                            </template>
                            <div v-if="item.message" class="el-form-item-msg">{{item.message}}</div>
                        </el-form-item>
                    </el-col>
                </template>
            </el-row>
		</el-form>
		<template #footer>
			<el-button @click="visible=false" >取 消</el-button>
			<el-button v-if="mode!='show'" type="primary" :loading="isSaveing" @click="submit()">保 存</el-button>
		</template>
	</el-dialog>
</template>

<script>
    import { defineAsyncComponent } from 'vue'
	const mnEditor = defineAsyncComponent(() => import('@/components/mnEditor'))
	const tableselectRender = defineAsyncComponent(() => import('./items/tableselect'))
	export default {
		emits: ['success', 'closed'],
        components: {
			mnEditor,
			tableselectRender
		},
        props: {
			//config: { type: Object, default: () => {} },
			loading: { type: Boolean, default: false },
			width:{type:Number,default:500},
			formItems: { type: Object,default:() => {}},
		},
		data() {
			return {
                config : {
				labelWidth: '130px',
				labelPosition: 'right',
				size: 'medium',
				tableItem:{
					istable:true,
					data:[]
				},
				formItems: [
					{
						label: "ElementPlus",
						component: "title",
					},
					{
						label: "图片",
						name: "img",
						select:true,
						value: "",
						component: "image",
					},
					{
						label: "输入框",
						name: "name",
						value: "",
						component: "input",
						options: {
							maxlength: "20",
							placeholder: "Activity name",
						},
						rules: [
							{required: true, message: "Please input Activity name", trigger: "blur"}
						],
						requiredHandle: "$.required==true",
					},
					{
						label: "栅格(12/24)",
						name: "name2",
						value: "",
						component: "input",
						span: 12,
						options: {
							placeholder: "span: 12",
						}
					},
					{
						label: "栅格(12/24)",
						name: "name3",
						value: "",
						component: "input",
						span: 12,
						options: {
							placeholder: "span: 12",
						}
					},
					{
						label: "选择器(多选)",
						name: "select",
						value: "",
						component: "select",
						span: 24,
						options: {
							remote: {
								api: `${this.$CONFIG.API_URL}/system/dic/get`,
								data: {name: 'a'}
							},
							multiple: true,
							items:[
								{
									label: "选项1",
									value: "1"
								},
								{
									label: "选项2",
									value: "2"
								}
							]
						},
						rules: [
							{required: true, message: "Please input Activity name", trigger: "change"}
						],
						requiredHandle: "$.required==true",
					},
					{
						label: "选择器(单选)",
						name: "select2",
						value: "",
						component: "select",
						span: 24,
						options: {
							remote: {
								api: `${this.$CONFIG.API_URL}/system/dic/get`,
								data: {name: 'b'}
							},
							items:[
								{
									label: "选项1",
									value: "1"
								},
								{
									label: "选项2",
									value: "2"
								}
							]
						}
					},
					{
						label: "级联选择器",
						name: "cascader",
						value: "",
						component: "cascader",
						span: 24,
						options: {
							items:[
								{
									label: "Guide",
									value: "guide",
									children: [
										{
											label: "Disciplines",
											value: "disciplines"
										},
										{
											label: "Consistency",
											value: "consistency"
										},
									]
								},
								{
									label: "Resource",
									value: "resource",
									children: [
										{
											label: "Axure Components",
											value: "axure"
										},
										{
											label: "Sketch Templates",
											value: "sketch"
										},
										{
											label: "Design Documentation",
											value: "docs"
										}
									]
								},
								{
									label: "Component",
									value: "component"
								},
							]
						}
					},
					{
						label: "多选框组",
						name: "checkboxGroup",
						value: [],
						component: "checkboxGroup",
						span: 24,
						options: {
							items:[
								{
									label: "选项1",
									value: "option1"
								},
								{
									label: "选项2",
									value: "option2"
								}
							]
						},
						hideHandle: "$.required==true"
					},
					{
						label: "单选",
						name: "radio",
						value: "1",
						component: "radio",
						options: {
							items:[
								{
									label: "选项1",
									value: "1"
								},
								{
									label: "选项2",
									value: "2"
								}
							]
						},
						hideHandle: "$.required==true"
					},
					{
						label: "开关",
						name: "required",
						message: "演示如何使用表达式动态显隐和必填，试试打开和关闭开关",
						value: false,
						component: "switch",
					},
					{
						label: "日期/时间",
						name: "date",
						value: "",
						component: "date",
						options: {
							type: "datetime",
							valueFormat: "YYYY-MM-DD HH:mm:ss",
						},
						rules: [
							{required: true, message: "Please input Data", trigger: "change"}
						],
					},
					{
						label: "滑块",
						name: "slider",
						value: 0,
						component: "slider",
						options: {
							marks: {
								0: '0°C',
								8: '8°C',
								37: '37°C'
							}
						}
					},
					{
						label: "数值",
						name: "number",
						value: 0,
						component: "number",
					},
					{
						label: "颜色",
						name: "color",
						value: "",
						component: "color",
					},
					{
						label: "评分",
						name: "rate",
						value: 0,
						component: "rate",
					},
					{
						label: "SASS扩展",
						component: "title",
					},
					// {
					// 	label: "表格选择器",
					// 	name: "tableselect",
					// 	value: {},
					// 	component: "tableselect",
					// 	span: 24,
					// 	options: {
					// 		apiObj: '$API.demo.page',
					// 		column: [
					// 			{
					// 				label: "ID",
					// 				prop: "id",
					// 				width:150
					// 			},
					// 			{
					// 				label: "姓名",
					// 				prop: "user"
					// 			}
					// 		],
					// 		props: {
					// 			label: 'user',
					// 			value: 'id',
					// 			keyword: "keyword"
					// 		}
					// 	}
					// },
					{
						label: "上传",
						component: "upload",
						options: {
							items:[
								{
									label: "图像1",
									name: "img1",
									value: ""
								},
								{
									label: "图像2",
									name: "img2",
									value: ""
								}
							]
						}
					},
					{
						label: "富文本",
						name: "text",
						value: "",
						component: "editor",
					},
				]
			},
				mode: "add",
				titleMap: {
					add: '新增',
					edit: '编辑',
					show: '查看'
				},
				visible: false,
				isSaveing: false,
				//表单数据
				form: {
					id:0,
					category:"",
					params:"",
					routerURl:"",
					trueURL:"",
					label:"",
					status:'',
					menu:'',
					sort:'',
					parentId:"",
					remark:""
				},
				//验证规则
				rules: {
					sort: [
						{required: true, message: '请输入排序', trigger: 'change'}
					],
					label: [
						{required: true, message: '请输入权限名称'}
					],
					routerURl:[
						{required: true, message: '请输入路由URL'}
					],
					trueURL:[
						{required: true, message: '请输入真实URL'}
					]
				},
				//所需数据选项
				groups: [],
				groupsProps: {
					value: "id",
					emitPath: false,
					checkStrictly: true
				}
			}
		},
		mounted() {
			this.getGroup()
		},
		methods: {
			//显示
			open(mode='add'){
				this.mode = mode;
				this.visible = true;
				return this
			},
			//加载树数据
			async getGroup(){
				// var res = await this.$API.system.dept.list.get();
				// this.groups = res.data;
				this.groups =  	[{
					"id":"0",
								"category":"system",
								"params":"?id=1",
								"routerURl":"/aaa/aaa",
								"trueURL":"/aaa/aaa",
								"label":"顶级节点",
								"status":1,
								"menu":1,
								"sort":1,
								"parentId":"",
								"children":[{
								"id":"1",
								"category":"system",
								"params":"?id=1",
								"routerURl":"/aaa/aaa",
								"trueURL":"/aaa/aaa",
								"label":"系统",
								"status":1,
								"menu":1,
								"sort":1,
								"parentId":"",
								"children":[{
									"children":[{
										"parentId":"11",
										"id":"100",
										"category":"system",
										"params":"",
										"routerURl":"/index",
										"trueURL":"/index",
										"label":"后台首页",
										"status":1,
										"menu":1,
										"sort":100,
									},{
										"id":"101",
										"category":"system",
										"params":"?id=1",
										"routerURl":"/aaa/aaa",
										"trueURL":"/aaa/aaa",
										"label":"清理缓存",
										"status":1,
										"menu":1,
										"sort":105,
									}],
									"parentId":"1",
									"id":"11",
									"category":"system",
									"params":"?id=1",
									"routerURl":"/bbb",
									"trueURL":"/bbb",
									"label":"平台首页",
									"status":1,
									"menu":1,
									"sort":11,
								},{
									"parentId":"1",
									"id":"12",
									"category":"system",
									"params":"?id=1",
									"routerURl":"/ccc",
									"trueURL":"/ccc",
									"label":"权限用户",
									"status":1,
									"menu":1,
									"sort":12,
								}]
							},{
								"parentId":"",
								"id":"145",
								"category":"system",
								"params":"",
								"routerURl":"/plug",
								"trueURL":"/plug",
								"label":"插件",
								"status":1,
								"menu":1,
								"sort":145,
								"children":[{
									"id":"146",
									"parentId":"145",
									"category":"system",
									"params":"",
									"routerURl":"/plug/a",
									"trueURL":"/plug/a",
									"label":"插件管理",
									"status":1,
									"menu":1,
									"sort":146,
								},{
									"id":"147",
									"parentId":"145",
									"category":"system",
									"params":"",
									"routerURl":"/plug/b",
									"trueURL":"/plug/b",
									"label":"已装插件",
									"status":1,
									"menu":1,
									"sort":147,
								}]
							},{
								"id":"196",
								"parentId":"",
								"category":"system",
								"params":"",
								"routerURl":"/app",
								"trueURL":"/app",
								"label":"应用",
								"status":1,
								"menu":1,
								"sort":196,
							}]
									}]

				
				
			},
			//表单提交方法
			submit(){
				this.$refs.dialogForm.validate(async (valid) => {
					if (valid) {
						this.isSaveing = true;
						var res = await this.$API.demo.post.post(this.form);
						this.isSaveing = false;
						if(res.code == 200){
							this.$emit('success', this.form, this.mode)
							this.visible = false;
							this.$message.success("操作成功")
						}else{
							this.$alert(res.message, "提示", {type: 'error'})
						}
					}
				})
			},
			//表单注入数据
			setData(data){
                this.from = data;
				// this.form.id = data.id
				// this.form.routerURl = data.routerURl
				// this.form.trueURL = data.trueURL
				// this.form.label = data.label
				// this.form.status = data.status
				// this.form.menu = data.menu
				// this.form.sort = data.sort
				// this.form.parentId = data.parentId
				// this.form.remark = data.remark
			}
		}
	}
</script>

<style scoped>
.imglist{
		margin-top: 10px;
		display: flex;
		align-items: center;
	}
	.img{
		width: 50px;
		height: 50px;
	}
	.imgbox{
		width: 60px;
		height: 60px;
		margin: 0 3px;
		border: 1px solid #f5f5f5;
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;
	}
</style>
